<template>
    <CCard >      
      <CCardBody>       
        <CRow>      
          <CCol sm="12" lg="12" >  
            <div class="content-wrapper">                            
              <div id="app">   
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas' height='500' :allowExcelExport='true'  :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='toolbar' :pageSettings='pageSettings' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings='selectionSettings' :rowSelected='rowSelected' 
                    :toolbarClick="toolbarClick" :recordDoubleClick="pubDoubleClick" >                             
                    <e-columns> 
                        <e-column field='is_quality' headerText='已檢驗' width='120'></e-column>                    
                        <e-column field='name' headerText='廠商名稱' width='180'></e-column>                      
                        <e-column field='sku_no' headerText='料號'  width='120'></e-column>              
                        <e-column field='sku_name' headerText='料名' width='250'></e-column>   
                        <e-column field='unit' headerText='單位' width='120'></e-column>   
                        <e-column field='sort' headerText='排序' width='120'></e-column>   
                        <e-column field='gdate' headerText='收料日期' width='140'></e-column>  
                        <e-column field='gcount' headerText='收料數量' width='140'></e-column>  
                        <e-column field='ua' headerText='採購單號' width='140'></e-column>     
                        <e-column field='receiptno' headerText='驗收單號' width='140'></e-column>                        
                        <e-column field='save_location' headerText='存放區數量數量' width='140' ></e-column>   
                        <e-column field='view_qty' headerText='存放區檢視數量' width='160'></e-column>   
                        <e-column field='quality_qty' headerText='品保抽檢數量' width='160'></e-column>
                        <e-column field='product_manager' headerText='生產組組長' width='150'></e-column> 
                        <e-column field='quality_manager' headerText='品保組組長' width='150'></e-column> 
                        <e-column field='write_user' headerText='填表人' width='140'></e-column>
                        <e-column field='report' headerText='報表' width='100' :template="urlTemplate" :allowFiltering='false'></e-column>
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
        </CRow>      

       <div class="control-section">
          <ejs-dialog ref="modalReceiveDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' 
                :header='"品保檢驗單"' :buttons='dialogFractionButtons' width='1000px'>          
              <div formGroup="orderForm"> 
                                      
                <div class="form-row">  
                    <div class="form-group col-md-12">
                     <div class="alert alert-primary" role="alert">
                        建立品保檢驗項目資料，檢查定義檢驗標準。
                     </div>
                    </div>   
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">料號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_sku_no" :enabled="false"></ejs-textbox>                              
                    </div>                    
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">品名</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_sku_name" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">進貨日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_input_date2" :enabled="false"></ejs-datepicker>                      
                    </div>
                      <div class="form-group col-md-3">
                        <span class="about-title-verify">檢驗日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_input_date" :enabled="true"></ejs-datepicker>                      
                    </div>
                    <div class="form-group col-md-6">
                        <span class="about-title-verify">廠商</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_name" :enabled="false"></ejs-textbox>                      
                    </div>
                    <div class="form-group col-md-6">
                        <span class="about-title-verify">驗收單號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_receiptno" :enabled="false"></ejs-textbox>                  
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">收料數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_save_location" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">存放區檢視數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_view_qty" :enabled="true"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-4">
                        <span class="about-title-verify">品保抽驗數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_quality_qty" :enabled="true"></ejs-textbox>                      
                    </div>
                    <div class="form-group col-md-12">
                      <div class="form-row">
                        <div class="col-md-2 box-header" style="border-top-width:1px; border-left-width:1px; ">
                            檢驗項目
                        </div>
                        <div class="col-md-3 box-header" style="border-top-width:1px; ">
                            檢驗標準
                        </div>
                        <div class="col-md-5 box-header" style="border-top-width:1px; ">
                            檢驗結果
                        </div>                      
                        <div class="col-md-2 box-header" style="border-top-width:1px; ">
                            備註  
                        </div>
                      </div>                 

                      <div v-for="(item, index) in this.quityListData" :key="index">
                        <div class="form-row">
                          <div class="col-md-2 box" style="border-left-width:1px; ">
                             <div class="form-group col-md-12">   <!--大於-->            
                                <div class="form-row">
                                  {{ item.name }}                                    
                                </div>                       
                            </div>  
                          </div>
                          <div class="col-md-3 box">
                            <div v-show="item.standard == 1" class="form-group col-md-12">   <!--大於-->            
                                <div class="form-row">
                                  ＞ {{ item.value1 }}                                    
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 2" class="form-group col-md-12">   <!--大於等於-->            
                                <div class="form-row">
                                  ≧ {{ item.value1 }}                                    
                                </div>                       
                            </div> 
                            <div v-show="item.standard == 3" class="form-group col-md-12">   <!--小於-->            
                                <div class="form-row">
                                  ＜ {{ item.value1 }}                                    
                                </div>                       
                            </div>   
                            <div v-show="item.standard == 4" class="form-group col-md-12">   <!--小於等於-->            
                                <div class="form-row">
                                  ≦ {{ item.value1 }}                                    
                                </div>                       
                            </div>  
                             <div v-show="item.standard == 5" class="form-group col-md-12">   <!--數值區間-->            
                                <div class="form-row">
                                  {{ item.value1 }} ~ {{ item.value2 }}
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 11" class="form-group col-md-12">  <!--尺寸(長*寬*高)-->                              
                                <div class="form-row">
                                  長{{ item.value1 }} * 寬{{ item.value2 }} * 高{{ item.value3 }} ± {{ item.value4 }}                                 
                                </div>
                            </div>    
                            <div v-show="item.standard == 12" class="form-group col-md-12">  <!--格數-->                              
                                <div class="form-row">
                                   {{ item.value1 }} ml * {{ item.value2 }} 入                            
                                </div>
                            </div>  
                            <div v-show="item.standard == 13" class="form-group col-md-12">  <!--厚度-->                              
                                <div class="form-row">
                                   {{ item.value1 }} ± {{ item.value2 }}                              
                                </div>
                            </div>  
                            <div v-show="item.standard == 14" class="form-group col-md-12">  <!--尺寸(長*寬)-->                              
                                <div class="form-row">
                                  長{{ item.value1 }} * 寬{{ item.value2 }} ± {{ item.value3 }}                                 
                                </div>
                            </div>  
                            <div v-show="item.standard == 21" class="form-group col-md-12">  <!--正常/不正常-->                              
                                <div class="form-row">
                                   正常                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 22" class="form-group col-md-12">  <!--完整/不完整-->                              
                                <div class="form-row">
                                   完整                             
                                </div>
                            </div>                            
                            <div v-show="item.standard == 23" class="form-group col-md-12">  <!--無/有-->                              
                                <div class="form-row">
                                   無                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 24" class="form-group col-md-12">  <!--平整/不平整-->                              
                                <div class="form-row">
                                   平整                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 25" class="form-group col-md-12">  <!--左出/右出-->                              
                                <div class="form-row">
                                   左出                             
                                </div>
                            </div>  
                            <div v-show="item.standard == 99" class="form-group col-md-12">  <!--不檢查-->                              
                                <div class="form-row">
                                   --                             
                                </div>
                            </div>
                          </div>
                          <div class="col-md-5 box">

                            <div v-show="item.standard == 1" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--大於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                     
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 2" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--大於等於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                 
                                </div>                       
                            </div> 
                            <div v-show="item.standard == 3" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--小於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                     
                                </div>                       
                            </div>   
                            <div v-show="item.standard == 4" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--小於等於-->            
                                <div class="form-row">
                                  <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div>                                     
                                </div>                       
                            </div>  
                             <div v-show="item.standard == 5" class="form-group col-md-12" style="margin-bottom: 0px;">   <!--數值區間-->            
                                <div class="form-row">
                                  <div class="form-group col-md-6" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" :min="0"></ejs-numerictextbox></div> 
                                </div>                       
                            </div>  
                            <div v-show="item.standard == 11" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--尺寸(長*寬*高)-->               
                                <div class="form-row">
                                  <div class="form-group col-md-3" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="長" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-3" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" placeholder="寬" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-3" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value3" placeholder="高" :min="0"></ejs-numerictextbox></div>  
                                  <div class="form-group col-md-3" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value4" placeholder="±" :min="0"></ejs-numerictextbox></div>  
                                </div>  
                            </div>    
                            <div v-show="item.standard == 12" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--格數-->                              
                                <div class="form-row">
                                  <div class="form-group col-md-6" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="ml" :min="0"></ejs-numerictextbox></div> 
                                  <div class="form-group col-md-6" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" :min="0"></ejs-numerictextbox></div>                              
                                </div>
                            </div>  
                            <div v-show="item.standard == 13" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--厚度-->                              
                                <div class="form-row">                            
                                    <div class="form-group col-md-6" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="mm" :min="0"></ejs-numerictextbox></div> 
                                    <div class="form-group col-md-6" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" placeholder="±" :min="0"></ejs-numerictextbox></div>                                            
                                </div>
                            </div>  
                            <div v-show="item.standard == 14" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--長*寬-->                              
                                <div class="form-row">                            
                                    <div class="form-group col-md-4" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value1" placeholder="長" :min="0"></ejs-numerictextbox></div>  
                                    <div class="form-group col-md-4" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value2" placeholder="寬" :min="0"></ejs-numerictextbox></div> 
                                    <div class="form-group col-md-4" style="margin-bottom: 0px;"><ejs-numerictextbox id="numeric" :step="1" v-model="item.real_value3" placeholder="±" :min="0"></ejs-numerictextbox></div>                                            
                                </div>
                            </div> 
                            <div v-show="item.standard == 21" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--正常/不正常-->                              
                                <div class="form-row">
                                  <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-dropdownlist :dataSource='sType21' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>
                                </div>
                            </div>  
                            <div v-show="item.standard == 22" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--完整/不完整-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-dropdownlist :dataSource='sType22' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>
                                </div>
                            </div>                          
                            <div v-show="item.standard == 23" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--無/有-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-dropdownlist :dataSource='sType23' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>                                                 
                                </div>
                            </div>  
                            <div v-show="item.standard == 24" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--平整/不平整-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-dropdownlist :dataSource='sType24' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>                                                    
                                </div>
                            </div>  
                            <div v-show="item.standard == 25" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--左出/右出-->                              
                                <div class="form-row">
                                   <div class="form-group col-md-12" style="margin-bottom: 0px;"><ejs-dropdownlist :dataSource='sType25' allowObjectBinding='true' v-model="item.real_value1" :fields='dropDownFields'></ejs-dropdownlist></div>                                                    
                                </div>
                            </div> 
                            <div v-show="item.standard == 99" class="form-group col-md-12" style="margin-bottom: 0px;">  <!--不檢查-->                              
                                <div class="form-row">
                                   --                             
                                </div>
                            </div>  
                          </div>
                          <div class="col-md-2 box">
                            <div class="form-row">
                              <div class="form-group col-md-12"  style="margin-bottom: 0px;"><ejs-textbox floatLabelType="Always"  v-model="item.remark"></ejs-textbox></div>                         
                            </div>
                          </div>                         
                        </div>
                      </div>
                      <div class="form-row" style="padding-top: 12px;">
                        <div class="form-group col-md-12">
                            <span class="about-title">備註</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_remark" :enabled="true"></ejs-textbox>                              
                        </div>
                       </div>  

                      <div class="form-row" style="padding-top: 12px;">
                        <div class="form-group col-md-6">
                            <span class="about-title">品保組組長</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_quality_manager" :enabled="false"></ejs-textbox>                              
                        </div>

                        <div class="form-group col-md-6">
                            <span class="about-title">填表人</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_write_user" :enabled="false"></ejs-textbox>                              
                        </div>
                       </div>  
                    </div>                      
                </div>
            </div>                 
          </ejs-dialog> 
        </div>




        <div class="control-section">
          <ejs-dialog ref="modalReceiveBottleDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' 
                :header='"品保檢驗單(空瓶)"' :buttons='dialogBottleButtons' width='1200px'>          
              <div formGroup="orderForm"> 
                                      
                <div class="form-row">  
                    <div class="form-group col-md-12">
                     <div class="alert alert-primary" role="alert">
                        建立品保檢驗項目資料，檢查定義檢驗標準(空瓶)。
                     </div>
                    </div>   
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">料號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_sku_no" :enabled="false"></ejs-textbox>                              
                    </div>                    
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">品名</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_sku_name" :enabled="false"></ejs-textbox>                              
                    </div>
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">廠商</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_name" :enabled="false"></ejs-textbox>                      
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">進貨日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_input_date2" :enabled="false"></ejs-datepicker>                      
                    </div>
                    <div class="form-group col-md-2">
                        <span class="about-title-verify">入庫日期</span>
                        <ejs-datepicker id="datepicker" format="yyyy-MM-dd" v-model="e_input_date" :enabled="true"></ejs-datepicker>                      
                    </div>

                    <div class="form-group col-md-3">
                        <span class="about-title-verify">生產批號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_batch_no" :enabled="true"></ejs-textbox>                  
                    </div>
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">採樣量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_quality_qty" :enabled="true"></ejs-textbox>                      
                    </div>                 
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">收料編號</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_receiptno" :enabled="false"></ejs-textbox>                  
                    </div>
                    <div class="form-group col-md-3">
                        <span class="about-title-verify">數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_save_location" :enabled="false"></ejs-textbox>                              
                    </div>
                    <!--<div class="form-group col-md-4">
                        <span class="about-title-verify">存放區檢視數量</span>
                        <ejs-textbox floatLabelType="Always" v-model="e_view_qty" :enabled="true"></ejs-textbox>                              
                    </div>-->
                   
                    <div class="form-group col-md-12">
                      <div class="form-row">
                        <div class="col box-header" style="border-top-width:1px; border-left-width:1px; ">
                            檢驗項目
                        </div>     
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('重量')) && this.quityListData.find(x => x.name.includes('重量')).standard < 20" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('重量')).name }}                         
                        </div>
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('內容')) && this.quityListData.find(x => x.name.includes('內容')).standard < 20" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('內容')).name }}     
                        </div> 
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('溫度'))" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('溫度')).name }}     
                        </div>              
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('內口徑')) && this.quityListData.find(x => x.name.includes('內口徑')).standard < 20" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('內口徑')).name }}     
                        </div>  
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('外口徑')) && this.quityListData.find(x => x.name.includes('外口徑')).standard < 20" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('外口徑')).name }}  
                        </div>                        
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('瓶頸')) && this.quityListData.find(x => x.name.includes('瓶頸')).standard < 20" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('瓶頸')).name }}  
                        </div>   
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('瓶高')) && this.quityListData.find(x => x.name.includes('瓶高')).standard < 20" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('瓶高')).name }}  
                        </div>  
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('外觀'))" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('外觀')).name }}  
                        </div>  
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('清潔'))" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('清潔')).name }}  
                        </div>
                        <div class="col box-header" v-if="this.quityListData.find(x => x.name.includes('病媒'))" style="border-top-width:1px; ">
                          {{ this.quityListData.find(x => x.name.includes('病媒')).name }}  
                        </div>                       
                      </div>                
                        
                      <div class="form-row">
                        <div class="col box-header2" style="border-top-width:1px; border-left-width:1px; ">
                            編號
                        </div>     

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('重量')) && this.quityListData.find(x => x.name.includes('重量')).standard < 20" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('重量')).standard == 1">  <!--大於-->            
                            ＞ {{ this.quityListData.find(x => x.name.includes('重量')).value1 }}                                                           
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('重量')).standard == 2">  <!--大於等於-->            
                            ≧ {{ this.quityListData.find(x => x.name.includes('重量')).value1 }}                                                           
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('重量')).standard == 3">  <!--小於-->            
                            ＜ {{ this.quityListData.find(x => x.name.includes('重量')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('重量')).standard == 3">  <!--小於等於-->            
                            ≦ {{ this.quityListData.find(x => x.name.includes('重量')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('重量')).standard == 5">   <!--數值區間--> 
                            {{ this.quityListData.find(x => x.name.includes('重量')).value1 }} ~ {{ this.quityListData.find(x => x.name.includes('重量')).value2 }}                      
                          </div>                        
                        </div>

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('內容')) && this.quityListData.find(x => x.name.includes('內容')).standard < 20" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('內容')).standard == 1">  <!--大於-->            
                            ＞ {{ this.quityListData.find(x => x.name.includes('內容')).value1 }}                                                           
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('內容')).standard == 2">  <!--大於等於-->            
                            ≧ {{ this.quityListData.find(x => x.name.includes('內容')).value1 }}                                                           
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('內容')).standard == 3">  <!--小於-->            
                            ＜ {{ this.quityListData.find(x => x.name.includes('內容')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('內容')).standard == 3">  <!--小於等於-->            
                            ≦ {{ this.quityListData.find(x => x.name.includes('內容')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('內容')).standard == 5">   <!--數值區間--> 
                            {{ this.quityListData.find(x => x.name.includes('內容')).value1 }} ~ {{ this.quityListData.find(x => x.name.includes('內容')).value2 }}                      
                          </div> 
                        </div>   
                        <div class="col box-header2" style="border-top-width:1px; ">
                          
                        </div>    

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('內口徑')) && this.quityListData.find(x => x.name.includes('內口徑')).standard < 20" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('內口徑')).standard == 1">  <!--大於-->            
                            ＞ {{ this.quityListData.find(x => x.name.includes('內口徑')).value1 }}                                                           
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('內口徑')).standard == 2">  <!--大於等於-->            
                            ≧ {{ this.quityListData.find(x => x.name.includes('內口徑')).value1 }}                                                           
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('內口徑')).standard == 3">  <!--小於-->            
                            ＜ {{ this.quityListData.find(x => x.name.includes('內口徑')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('內口徑')).standard == 3">  <!--小於等於-->            
                            ≦ {{ this.quityListData.find(x => x.name.includes('內口徑')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('內口徑')).standard == 5">   <!--數值區間--> 
                            {{ this.quityListData.find(x => x.name.includes('內口徑')).value1 }} ~ {{ this.quityListData.find(x => x.name.includes('內口徑')).value2 }}                      
                          </div>    
                        </div> 


                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('外口徑')) && this.quityListData.find(x => x.name.includes('外口徑')).standard < 20" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('外口徑')).standard == 1">  <!--大於-->            
                            ＞ {{ this.quityListData.find(x => x.name.includes('外口徑')).value1 }}                                                           
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('外口徑')).standard == 2">  <!--大於等於-->            
                            ≧ {{ this.quityListData.find(x => x.name.includes('外口徑')).value1 }}                                                           
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('外口徑')).standard == 3">  <!--小於-->            
                            ＜ {{ this.quityListData.find(x => x.name.includes('外口徑')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('外口徑')).standard == 3">  <!--小於等於-->            
                            ≦ {{ this.quityListData.find(x => x.name.includes('外口徑')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('外口徑')).standard == 5">   <!--數值區間--> 
                            {{ this.quityListData.find(x => x.name.includes('外口徑')).value1 }} ~ {{ this.quityListData.find(x => x.name.includes('外口徑')).value2 }}                      
                          </div> 
                        </div>  

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('瓶頸')) && this.quityListData.find(x => x.name.includes('瓶頸')).standard < 20" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶頸')).standard == 1">  <!--大於-->            
                            ＞ {{ this.quityListData.find(x => x.name.includes('瓶頸')).value1 }}                                                           
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶頸')).standard == 2">  <!--大於等於-->            
                            ≧ {{ this.quityListData.find(x => x.name.includes('瓶頸')).value1 }}                                                           
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶頸')).standard == 3">  <!--小於-->            
                            ＜ {{ this.quityListData.find(x => x.name.includes('瓶頸')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶頸')).standard == 3">  <!--小於等於-->            
                            ≦ {{ this.quityListData.find(x => x.name.includes('瓶頸')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶頸')).standard == 5">   <!--數值區間--> 
                            {{ this.quityListData.find(x => x.name.includes('瓶頸')).value1 }} ~ {{ this.quityListData.find(x => x.name.includes('瓶頸')).value2 }}                      
                          </div> 
                        </div>   

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('瓶高')) && this.quityListData.find(x => x.name.includes('瓶高')).standard < 20" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶高')).standard == 1">  <!--大於-->            
                            ＞ {{ this.quityListData.find(x => x.name.includes('瓶高')).value1 }}                                                           
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶高')).standard == 2">  <!--大於等於-->            
                            ≧ {{ this.quityListData.find(x => x.name.includes('瓶高')).value1 }}                                                           
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶高')).standard == 3">  <!--小於-->            
                            ＜ {{ this.quityListData.find(x => x.name.includes('瓶高')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶高')).standard == 3">  <!--小於等於-->            
                            ≦ {{ this.quityListData.find(x => x.name.includes('瓶高')).value1 }}                                                           
                          </div>
                          <div v-show="this.quityListData.find(x => x.name.includes('瓶高')).standard == 5">   <!--數值區間--> 
                            {{ this.quityListData.find(x => x.name.includes('瓶高')).value1 }} ~ {{ this.quityListData.find(x => x.name.includes('瓶高')).value2 }}                      
                          </div> 
                        </div> 

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('外觀'))" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('外觀')).standard == 21">  <!--正常/不正常-->              
                            正常                                                                                     
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('外觀')).standard == 22">  <!--完整/不完整-->              
                            完整                                                                                     
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('外觀')).standard == 23">  <!--無/有-->              
                            無                                                                                      
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('外觀')).standard == 24">  <!--平整/不平整-->             
                            平整                                                                                      
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('外觀')).standard == 25">  <!--左出/右出-->           
                            左出                                                                                      
                          </div>  
                        </div> 

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('清潔'))" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('清潔')).standard == 21">  <!--正常/不正常-->              
                            正常                                                                                     
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('清潔')).standard == 22">  <!--完整/不完整-->              
                            完整                                                                                     
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('清潔')).standard == 23">  <!--無/有-->              
                            無                                                                                      
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('清潔')).standard == 24">  <!--平整/不平整-->             
                            平整                                                                                      
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('清潔')).standard == 25">  <!--左出/右出-->           
                            左出                                                                                      
                          </div>  
                        </div>

                        <div class="col box-header2" v-if="this.quityListData.find(x => x.name.includes('病媒'))" style="border-top-width:1px; ">
                          <div v-show="this.quityListData.find(x => x.name.includes('病媒')).standard == 21">  <!--正常/不正常-->              
                            正常                                                                                     
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('病媒')).standard == 22">  <!--完整/不完整-->              
                            完整                                                                                     
                          </div> 
                          <div v-show="this.quityListData.find(x => x.name.includes('病媒')).standard == 23">  <!--無/有-->              
                            無                                                                                      
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('病媒')).standard == 24">  <!--平整/不平整-->             
                            平整                                                                                      
                          </div>  
                          <div v-show="this.quityListData.find(x => x.name.includes('病媒')).standard == 25">  <!--左出/右出-->           
                            左出                                                                                      
                          </div>    
                        </div>   
                      </div>                   
            
                      <div v-for="(item, index) in 10" :key="index">
                        <div class="form-row">
                          <div class="col box" style="border-top-width:1px; border-left-width:1px; text-align: center;">                            
                            <div v-if="bottle_data.length >= 50" style="border-top-width:1px; border-left-width:1px; text-align: center;">
                                 {{ index + 1 }}
                            </div>                           
                          </div>     
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('重量')) && quityListData.find(x => x.name.includes('重量')).standard < 20" style="border-top-width:1px; ">
                            <div class="form-group col-md-12" style="margin-bottom: 0px;">
                              <div v-if="bottle_data.length >= 10">
                                <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('重量')).name ).real_value1" :min="0"></ejs-numerictextbox>
                              </div>                              
                            </div> 
                          </div>
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('內容')) && quityListData.find(x => x.name.includes('內容')).standard < 20" style="border-top-width:1px; ">
                            <div v-if="bottle_data.length >= 10">
                              <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('內容')).name ).real_value1" :min="0"></ejs-numerictextbox>
                            </div>    
                          </div>  
                           <div class="col box" v-if="quityListData.find(x => x.name.includes('溫度')) && quityListData.find(x => x.name.includes('溫度')).standard < 20" style="border-top-width:1px; ">
                            <div v-if="bottle_data.length >= 10">
                              <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('溫度')).name ).real_value1" :min="0"></ejs-numerictextbox>
                            </div>    
                          </div>  
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('內口徑')) && quityListData.find(x => x.name.includes('內口徑')).standard < 20" style="border-top-width:1px; ">
                             <div v-if="bottle_data.length >= 10">
                              <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('內口徑')).name ).real_value1" :min="0"></ejs-numerictextbox>
                            </div>  
                          </div> 
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('外口徑')) && quityListData.find(x => x.name.includes('外口徑')).standard < 20" style="border-top-width:1px; ">
                            <div v-if="bottle_data.length >= 10">
                              <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('外口徑')).name ).real_value1" :min="0"></ejs-numerictextbox>
                            </div>  
                          </div> 
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('瓶頸')) && quityListData.find(x => x.name.includes('瓶頸')).standard < 20" style="border-top-width:1px; ">
                            <div v-if="bottle_data.length >= 10">
                              <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('瓶頸')).name ).real_value1" :min="0"></ejs-numerictextbox>
                            </div> 
                          </div>   
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('瓶高')) && quityListData.find(x => x.name.includes('瓶高')).standard < 20" style="border-top-width:1px; ">
                            <div v-if="bottle_data.length >= 10">
                              <ejs-numerictextbox id="numeric" :step="1" v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('瓶高')).name ).real_value1" :min="0"></ejs-numerictextbox>
                            </div> 
                          </div>  
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('外觀'))" style="border-top-width:1px; ">
                            <div v-show="quityListData.find(x => x.name.includes('外觀')).standard == 21">  <!--正常/不正常-->          
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType21' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('外觀')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div> 
                            <div v-show="quityListData.find(x => x.name.includes('外觀')).standard == 22">  <!--完整/不完整-->              
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType22' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('外觀')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div> 
                            <div v-show="quityListData.find(x => x.name.includes('外觀')).standard == 23">  <!--無/有-->              
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType23' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('外觀')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                            <div v-show="quityListData.find(x => x.name.includes('外觀')).standard == 24">  <!--平整/不平整-->             
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType24' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('外觀')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                            <div v-show="quityListData.find(x => x.name.includes('外觀')).standard == 25">  <!--左出/右出-->           
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType25' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('外觀')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                          </div>  
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('清潔'))" style="border-top-width:1px; ">
                            <div v-show="quityListData.find(x => x.name.includes('清潔')).standard == 21">  <!--正常/不正常-->          
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType21' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('清潔')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div> 
                            <div v-show="quityListData.find(x => x.name.includes('清潔')).standard == 22">  <!--完整/不完整-->              
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType22' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('清潔')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div> 
                            <div v-show="quityListData.find(x => x.name.includes('清潔')).standard == 23">  <!--無/有-->              
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType23' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('清潔')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                            <div v-show="quityListData.find(x => x.name.includes('清潔')).standard == 24">  <!--平整/不平整-->             
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType24' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('清潔')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                            <div v-show="quityListData.find(x => x.name.includes('清潔')).standard == 25">  <!--左出/右出-->           
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType25' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('清潔')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                          </div>
                          <div class="col box" v-if="quityListData.find(x => x.name.includes('病媒'))" style="border-top-width:1px; ">
                            <div v-show="quityListData.find(x => x.name.includes('病媒')).standard == 21">  <!--正常/不正常-->          
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType21' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('病媒')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div> 
                            <div v-show="quityListData.find(x => x.name.includes('病媒')).standard == 22">  <!--完整/不完整-->              
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType22' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('病媒')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div> 
                            <div v-show="quityListData.find(x => x.name.includes('病媒')).standard == 23">  <!--無/有-->              
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType23' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('病媒')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                            <div v-show="quityListData.find(x => x.name.includes('病媒')).standard == 24">  <!--平整/不平整-->             
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType24' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('病媒')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                            <div v-show="quityListData.find(x => x.name.includes('病媒')).standard == 25">  <!--左出/右出-->           
                              <div v-if="bottle_data.length >= 10">
                                <ejs-dropdownlist :dataSource='sType25' v-model="bottle_data.find(x => x.no == index + 1 && x.name == quityListData.find(x => x.name.includes('病媒')).name ).real_value1" allowObjectBinding='true'  :fields='dropDownFields'></ejs-dropdownlist>
                              </div> 
                            </div>  
                          </div>    
                        </div>
                      </div>

                      <div class="form-row" style="padding-top: 12px;">
                        <div class="form-group col-md-12">
                            <span class="about-title">備註</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_remark" :enabled="true"></ejs-textbox>                              
                        </div>
                       </div>  
             
                      <div class="form-row" style="padding-top: 12px;">
                        <div class="form-group col-md-6">
                            <span class="about-title">品保組組長</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_quality_manager" :enabled="false"></ejs-textbox>                              
                        </div>

                        <div class="form-group col-md-6">
                            <span class="about-title">填表人</span>
                            <ejs-textbox floatLabelType="Always" v-model="e_write_user" :enabled="false"></ejs-textbox>                              
                        </div>
                       </div>  
                    </div>                      
                </div>
            </div>                 
          </ejs-dialog> 
        </div>

        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>    
      </CCardBody>   
    </CCard>
  </template>
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script>
  
import Vue from "vue";
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Sort, Toolbar, Edit, Filter, ExcelExport, Reorder } from "@syncfusion/ej2-vue-grids";
import { ColumnSeries, DataLabel, LineSeries, SplineSeries, SplineAreaSeries, Legend, Tooltip, DateTime, Category, Highlight, ChartAnnotation, StripLine } from "@syncfusion/ej2-vue-charts";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import zhtwLocalization  from '../language/language.json';
  
L10n.load(zhtwLocalization);
Vue.use(TooltipPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DialogPlugin);
Vue.prototype.$eventHub = new Vue(); 
enableRipple(true);

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-toast': ToastComponent,
    'ejs-datepicker': DatePickerComponent
  },
  provide : {
    grid: [Page, Sort, Toolbar, Edit, Filter, ExcelExport, Reorder],
        chart: [ColumnSeries, SplineAreaSeries, LineSeries, SplineSeries, Legend, Tooltip, Category,DateTime, DataLabel, Highlight, ChartAnnotation, StripLine],
  },
  name: 'acceptance_scm',
  data: function() {
    return {
      bottle_data: [],
      e_receiptno:null, e_batch_no: null,
      datas : [], quityData : [], quityListData : [],
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      pageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },     
      e_sku_no: null, e_sku_name: null, e_name: null,
      e_quality_id : null, e_check_list_id: null,
      e_input_date2: null,e_input_date: null, e_acceptance_no: null, e_save_location: null, e_view_qty: null, e_quality_qty :null, e_quality_manager : null, e_write_user : null,
      e_remark: null,
      sType21: [ {text: '正常' , value: 0},  {text: '不正常' , value: 1}],
      sType22: [ {text: '完整' , value: 0},  {text: '不完整' , value: 1}],
      sType23: [ {text: '無' , value: 0},  {text: '有' , value: 1}],
      sType24: [ {text: '平整' , value: 0},  {text: '不平整' , value: 1}],
      sType25: [ {text: '左出' , value: 0},  {text: '右出' , value: 1}],
      dropDownFields: { text: 'text', value: 'value' },

      toolbar: [             
        { text: '品保檢驗', tooltipText: '品保檢驗', prefixIcon: 'e-btn-icon e-description e-icons e-icon-left', id: 'Check', disabled: localStorage.getItem('scm').indexOf('42') < 0}, 
        { text: '生產組組長簽核', tooltipText: '生產組組長簽核', prefixIcon: 'e-btn-icon e-signature e-icons e-icon-left', id: 'Sign1', disabled : localStorage.getItem('scm').indexOf('44')< 0 },
        { text: '品保組組長簽核', tooltipText: '品保組組長簽核', prefixIcon: 'e-btn-icon e-signature e-icons e-icon-left', id: 'Sign2', disabled : localStorage.getItem('scm').indexOf('43')< 0 },
        { text: '填表人簽核', tooltipText: '填表人簽核', prefixIcon: 'e-btn-icon e-signature e-icons e-icon-left', id: 'Sign3', disabled : localStorage.getItem('scm').indexOf('45')< 0 },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search'],   
      selectionSettings: { type: 'Single' , persistSelection: true },
      filterSettings: { type: 'CheckBox' }, 
      visible : false,
      e_selectData : null, e_selectRow: null,
      e_pwd: '', e_pwd2: '', e_header: '', e_fraction_header: '',
      e_quality: 12, e_delivery_date: 1, e_fit: 2, e_service: 3,        
      position: { X: 'Right', Y: "Bottom" },
      min: 0,
      max: 25,
      shwbuttons: true,
      step: 1,
      checked: false,
      isenable: true,
      readonly: false,
      orientation: "Horizontal", 
      ticks: { placement: 'After', largeStep: 25 },
      type: 'MinRange',
      dialogFractionButtons: [{
          click: this.dialogFractionOkClick,
          buttonModel: { content: '確認', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
      }],

      dialogBottleButtons: [{
          click: this.dialogBottleOkClick,
          buttonModel: { content: '確認', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
      }],

      e_sign :null,
      urlTemplate: function () {
        return {
          template: Vue.component('yesnoTemplate', {
            template: `<div id="coordinates" v-show="data.is_quality == true">
                      <span id="locationtext"><a @click="doSomething" href="#" ><img src="img/icon/report.png" class="e-image" width="30px" :alt="data.report"/></a></span>        
                      </div>`,
            data: function () { return { data: {} }; },
            methods: { 
              doSomething(e) {
                e.preventDefault(); 
                this.$eventHub.$emit('reportQuality',this.data);
              } 
            }                         
          })
        }
      },
    };
  },
  methods: {    
    onload:function() {
      // 初始化
    },
    submit:function() {
      this.$emit('onGetMaterialsClose');
    },
    beforeRender: function (args) {
        if (args.target.closest("td")) {
            this.$refs.tooltip.content = args.target.innerText;                
        }
    },

    onReport: function(e) {
      let pdfname = '原材料驗收檢驗單';
      if(e.is_bottle){
        pdfname = '空瓶檢驗紀錄表';
      }
      fetch(Vue.prototype.GLOBAL.baseURL+`InputCheck/Quality/Report?SignID=${e.signID}&CheckListId=${e.check_list_id}&IsBottle=${e.is_bottle}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      })
      .then(res => res.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.formatDate(new Date(e.gdate))} ${pdfname}`; // 留空，瀏覽器就會使用後端回傳的 Content-Disposition 檔名
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(url);
      });
    },
    onQualityChange: function(args) {
      this.e_quality = args.value;
    },
    onDeliveryDateChange: function(args) {
      this.e_delivery_date = args.value;
    },
    onFitChange: function(args) {
      this.e_fit = args.value;
    },
    onServiceChange: function(args) {
      this.e_service = args.value;
    },
    fixDate(d) {
      return new Date(d.getTime() + 8 * 60 * 60 * 1000);
    },
    pubDoubleClick: function () {  
      if (this.e_selectData == null)
      {
        this.showMsg('請先選擇一筆資料');
        return;
      }
      if (this.e_selectData.is_bottle)
        this.$refs.modalReceiveBottleDialog.show();
      else 
        this.$refs.modalReceiveDialog.show();       
    },
    editOkClick: function () {           
      this.upData();         
    },
    valueChange: function () {  
      this.isDataChanged = true;
      this.stTime = null;
    },
    load: function() {   

    },       
    addAction: function() {

    },     
    
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    }, 
    dialogFractionOkClick: function() {
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/InputCheck/Quality`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            header : {
              input_date : this.fixDate(this.e_input_date),
              acceptance_no : this.e_acceptance_no,
              save_location : this.e_save_location,
              view_qty : this.e_view_qty,
              quality_qty : this.e_quality_qty,
              quality_manager : this.e_quality_manager,
              write_user : this.e_write_user,
              quality_id : this.e_quality_id,
              check_list_id : this.e_check_list_id,
              remark : this.e_remark
             },
            body : this.quityListData     
          }    
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.getQualityList();
        this.$refs.modalReceiveDialog.hide();
        this.showMsg('建立品保檢驗完成');
      })
      .catch((error) => { 
        this.showError(error) }
      )       
    },
    dialogBottleOkClick: function() {
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/InputCheck/Quality/Bottle`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            header : {
              input_date : this.fixDate(this.e_input_date),
              acceptance_no : this.e_acceptance_no,
              save_location : this.e_save_location,
              view_qty : this.e_view_qty,
              quality_qty : this.e_quality_qty,
              quality_manager : this.e_quality_manager,
              write_user : this.e_write_user,
              quality_id : this.e_quality_id,
              batch_no : this.e_batch_no,
              check_list_id : this.e_check_list_id,
              remark : this.e_remark
             },
            body : this.bottle_data     
          }    
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.getQualityList();
        this.$refs.modalReceiveBottleDialog.hide();
        this.showMsg('建立品保檢驗完成');
      })
      .catch((error) => { 
        this.showError(error) }
      )       
    },
    toolbarClick: function(args) {
      if (args.item.id == "Export") {
        this.$refs.grid.excelExport({ fileName:'品保檢驗.xlsx' });
      }
      if (args.item.id == "Sign1") {
        this.$swal({
            title: `確認是否進行生產組組長簽核?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: '是',
            cancelButtonText: '否'
        }).then((result) => {
          if (result.isConfirmed) {     
              this.addSign(1);
          } else {
              return; 
          }
        });
      }
      if (args.item.id == "Sign2") {
        this.$swal({
            title: `確認是否進行品保組組長簽核?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: '是',
            cancelButtonText: '否'
        }).then((result) => {
          if (result.isConfirmed) {     
              this.addSign(2);
          } else {
              return; 
          }
        });
      }
      if (args.item.id == "Sign3") {
        this.$swal({
            title: `確認是否進行填表人簽核?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: '是',
            cancelButtonText: '否'
        }).then((result) => {
          if (result.isConfirmed) {     
              this.addSign(3);
          } else {
              return; 
          }
        });
      }
      if (args.item.id == "Check") {      
        if (this.e_selectData == null)
        {
          this.showMsg('請先選擇一筆資料');
          return;
        }
        if (this.e_selectData.is_bottle)
          this.$refs.modalReceiveBottleDialog.show();
        else 
          this.$refs.modalReceiveDialog.show();       
       
      }
    },   
    addSign: function(arg) {
      this.axios({
        method: 'post',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/InputCheck/Quality/Sign`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data:{
            id:this.e_sign,
            type:arg
        }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.getQualityList();
        this.$refs.toastRef.show( { title: '訊息!', content: "簽名成功", cssClass: 'e-toast-info', icon: 'e-warning toast-icons' });
      })
      .catch((error) => { 
        this.showError(error, true) }
      )
    },
    actionComplete: function() {                             
    },
    rowSelected: function(args) {        
      const current = args.rowIndex;
      if (this._last === current) return;
      this._last = current;
      this.e_selectRow = args.row.getAttribute('aria-rowindex');  
      this.e_selectData = args.data; 
      this.e_input_date2 = args.data.gdate;
      this.e_receiptno = args.data.receiptno;
      this.e_sku_no = this.e_selectData.sku_no;
      this.e_save_location = args.data.gcount;
      this.e_sku_name = this.e_selectData.sku_name;
      this.e_name = this.e_selectData.name;
      this.e_quality_manager = args.data.quality_manager;
      this.e_write_user = args.data.write_user;
      this.e_sign = [args.data].map(r => r.signID);
      this.getQuality();
    },    
    getQualityList: function() {    
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/InputCheck/Quality/List`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.datas = response.data.datas;
        this.e_selectData = null;
        this.e_selectRow = null;
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       
    getQuality: function() {    
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/InputCheck/Quality?check_list_id=${this.e_selectData.check_list_id}&sku_no=${this.e_sku_no}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
      
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.quityData = response.data.datas.header;     
        this.quityListData = response.data.datas.body;
        this.e_input_date = response.data.datas.header.input_date;
        this.e_acceptance_no = response.data.datas.header.acceptance_no;
        this.e_view_qty = response.data.datas.header.view_qty;
        this.e_quality_qty = response.data.datas.header.quality_qty;
        this.e_quality_id = response.data.datas.header.quality_id;
        this.e_check_list_id = response.data.datas.header.check_list_id;
        this.e_batch_no = response.data.datas.header.batch_no;
        this.e_remark = response.data.datas.header.remark;
        if (this.e_selectData.is_bottle == true) {
          if (this.e_selectData.is_quality == false) {
            this.getBottle();
          } else {
            this.bottle_data = response.data.datas.body;
          }
        }
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       
    getBottle() {
      var tmpBottle_data = [];

      this.quityListData.push({ 
        name: "溫度°C", 
        no: null, 
        standard: 0, 
        value1: null, 
        value2: null, 
        value3: null, 
        value4: null, 
        real_value1: 0, 
        real_value2: null, 
        real_value3: null, 
        real_value4: null, 
        remark: null 
      });
     
      for(var i = 1; i <= 10; i++) {
        for(var v in this.quityListData){
          tmpBottle_data.push({ 
            no: i,
            name: this.quityListData[v].name, 
            real_value1: this.quityListData[v].real_value1,
            real_value2: this.quityListData[v].real_value2,
            real_value3: this.quityListData[v].real_value3,
            real_value4: this.quityListData[v].real_value4,
            value1: this.quityListData[v].value1,
            value2: this.quityListData[v].value2,
            value3: this.quityListData[v].value3,
            value4: this.quityListData[v].value4,
            standard: this.quityListData[v].standard
          });
        }     
      } 
      this.bottle_data = tmpBottle_data;
      console.log(this.bottle_data);
      
    },
    formatDate(date) {
      let yyyy = date.getFullYear();
      let mm = String(date.getMonth() + 1).padStart(2, '0');      
      let dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showError: function (error) {     
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
  },

  created() {
  
    this.getQualityList();
    this.$eventHub.$on('reportQuality', (e)=>{
      this.onReport(e);
    }); 
  },

  mounted() {
   
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
    this.$eventHub.$off('reportQuality');
  }  
}
</script>
<style scoped>
  .box {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 4px; 
    border-left-width: 0px;
    display: flex;
    align-items: center;  
    height: 38px;
  }
  .box-header {
    border-style:solid; 
    border-color: #ced2d8; 
    background-color: rgb(202, 194, 194);
    border-width:1px;
    border-top-width:0px; 
    padding-top: 9px; 
    border-left-width: 0px;
    text-align: center;
    height: 38px;
  }
  .box-header2 {
    border-style:solid; 
    border-color: #ced2d8;   
    border-width:1px;
    border-top-width:0px; 
    padding-top: 9px; 
    border-left-width: 0px;
    text-align: center;
    height: 38px;
  }
</style>
<style lang="scss" src="../../scss/base.scss"></style>